import LatestNews2 from "../../assets/LatestNews2.svg";
import { useGetAllNewsQuery } from "../../redux/Service/api";
function LatestNews() {
  const { data, isLoading, isError } = useGetAllNewsQuery(undefined);
  const allNews = data?.data ?? [];

  return (
    <section className="bg-gray-50 py-8 sm:py-12 md:py-16">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="mb-6 sm:mb-8 md:mb-12">
          <h2
            className="text-xl sm:text-2xl md:text-4xl font-bold text-right
            bg-gradient-to-l from-purple-900 to-blue-900 text-transparent bg-clip-text
            relative inline-block"
          >
            اخر الاخبار
            <span className="absolute bottom-0 right-0 w-1/2 h-1 bg-blue-600 rounded-full"></span>
          </h2>
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-3 mid:grid-cols-2 midd:grid-cols-1 gap-4 sm:gap-6 md:gap-8">
          {/* Loading State */}
          {isLoading && (
            <div className="animate-pulse space-y-4 mid:col-span-2 midd:col-span-1">
              {[1, 2, 3].map((item) => (
                <div
                  key={item}
                  className="h-[200px] sm:h-[250px] md:h-[300px] bg-gray-200 rounded-xl sm:rounded-2xl"
                ></div>
              ))}
            </div>
          )}

          {/* Error State */}
          {isError && (
            <div
              className="group relative overflow-hidden rounded-xl sm:rounded-2xl shadow-lg 
              transition-all duration-300 hover:shadow-xl
              transform hover:-translate-y-1"
            >
              {/* Image Container */}
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={LatestNews2}
                  alt={"latest news"}
                  className="w-full h-full object-cover transform 
                  group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Content Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent">
                <div className="absolute bottom-0 p-4 sm:p-6 w-full">
                  <h3
                    className="text-white text-base sm:text-lg md:text-xl font-semibold 
                    leading-tight mb-2 text-right"
                  >
                    السعودية تلغي رسوم تراخيص الفنادق في مسعى لدعم السياحة
                  </h3>

                  <div className="flex justify-end items-center gap-2 text-gray-300 text-xs sm:text-sm">
                    <span>{new Date().toLocaleDateString("ar-SA")}</span>
                    <svg
                      className="w-3 h-3 sm:w-4 sm:h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Hover Overlay */}
              <div
                className="absolute inset-0 bg-blue-600/20 opacity-0 
                group-hover:opacity-100 transition-opacity duration-300"
              ></div>
            </div>
          )}

          {/* News Cards */}
          {!isLoading &&
            !isError &&
            allNews?.map((item: any) => (
              <div
                key={item.id}
                className="group relative overflow-hidden rounded-xl sm:rounded-2xl shadow-lg 
                transition-all duration-300 hover:shadow-xl
                transform hover:-translate-y-1"
              >
                {/* Image Container */}
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={item.photo}
                    alt={item.title}
                    className="w-full h-full object-cover transform 
                    group-hover:scale-110 transition-transform duration-500"
                  />
                </div>

                {/* Content Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent">
                  <div className="absolute bottom-0 p-4 sm:p-6 w-full">
                    <h3
                      className="text-white text-base sm:text-lg md:text-xl font-semibold 
                      leading-tight mb-2 text-right line-clamp-2"
                    >
                      {item.title}
                    </h3>

                    <div className="flex justify-end items-center gap-2 text-gray-300 text-xs sm:text-sm">
                      <span>
                        {new Date(item.created_at).toLocaleDateString("ar-SA")}
                      </span>
                      <svg
                        className="w-3 h-3 sm:w-4 sm:h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Hover Overlay */}
                <div
                  className="absolute inset-0 bg-blue-600/20 opacity-0 
                  group-hover:opacity-100 transition-opacity duration-300"
                ></div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}

export default LatestNews;
